// The built-in demonstration fixture must never synchronise with live services.
export const SAMPLE_MATCH_ID = '126571a4-2e62-469b-a361-53038f57a8fd'

export const isSampleMatch = (matchId: string | undefined) => matchId?.toLowerCase() === SAMPLE_MATCH_ID
